import { Controller } from "@hotwired/stimulus"
import { fetchCsrf } from "../../global/javascript/fetch_csrf"

export default class extends Controller {
  static targets = ["form", "description"]

  connect() {
    fetchCsrf()
  }

  onPostSuccess(event) {
    let [data,,] = event.detail
    this.descriptionTarget.innerHTML = data.message
    this.descriptionTarget.classList.remove("hidden")
  }

  onPostError(event) {
    let [data,,] = event.detail
    this.descriptionTarget.innerHTML = data.message
    this.descriptionTarget.classList.remove("hidden")
  }
}
